import { createRef } from 'react'
import { Autosuggest, AutosuggestProps } from '@machobear/design-system'
import { useField, useFormikContext } from 'formik'
import noop from 'lodash/noop'
import useFocusOnError from '@/hooks/use-focus-on-error'

type AutoSuggestFieldInputProps = AutosuggestProps<string> & { name: string; message?: string }

export const AutoSuggestFieldInput = ({
  name,
  onChange = noop,
  onBlur = noop,
  required = false,
  disabled = false,
  message,
  ...props
}: AutoSuggestFieldInputProps) => {
  const fieldRef = createRef<HTMLInputElement>()
  const [, meta] = useField(name)
  const { setFieldValue } = useFormikContext()
  const { error, touched } = meta

  useFocusOnError({ fieldRef, name })

  const onChangeField = (e: any) => {
    if (e) {
      setFieldValue(name, e)
      onChange(e)
    }
  }

  const errorMessage = message || error

  return (
    <Autosuggest
      ref={fieldRef}
      name={name}
      onChange={onChangeField}
      required={required}
      disabled={disabled}
      message={error && touched ? errorMessage : null}
      tone={error && touched ? 'critical' : 'neutral'}
      {...props}
    />
  )
}
